var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _vm.hasImage
      ? _c("span", { staticClass: "ico_bbs ico_picture" }, [_vm._v("사진첨부")])
      : _vm._e(),
    _vm._v(" "),
    _vm.hasVideo
      ? _c("span", { staticClass: "ico_bbs ico_video" }, [_vm._v("동영상첨부")])
      : _vm._e(),
    _vm._v(" "),
    _vm.hasFile
      ? _c("span", { staticClass: "ico_bbs ico_file" }, [_vm._v("파일첨부")])
      : _vm._e(),
    _vm._v(" "),
    _vm.hasPoll
      ? _c("span", { staticClass: "ico_bbs ico_vote" }, [_vm._v("투표글")])
      : _vm._e(),
    _vm._v(" "),
    _vm.isSafeTrade
      ? _c("span", { staticClass: "tag_item" }, [_vm._v("안전거래")])
      : _vm._e(),
    _vm._v(" "),
    _vm.isSold
      ? _c("span", { staticClass: "tag_item" }, [_vm._v("판매완료")])
      : _vm._e(),
    _vm._v(" "),
    _vm.isNew
      ? _c("span", { staticClass: "ico_bbs ico_new" }, [_vm._v("새글")])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }